module.exports = __webpack_public_path__ + "media/components/assets/img/logo/testimonials/summer-bench-2f3476d679576d4834b64b3cbfce0688.png";